<template>
  <transition name="toast">
    <div v-if="visible" :class="['notification-toast', type]">
      <div class="toast-icon">
        <span v-if="type === 'success'">✓</span>
        <span v-else-if="type === 'error'">✕</span>
        <span v-else>ℹ</span>
      </div>
      <div class="toast-content">
        <div class="toast-title">{{ title }}</div>
        <div class="toast-message" v-if="message">{{ message }}</div>
      </div>
      <button class="toast-close" @click="close">×</button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'NotificationToast',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'info', // 'success', 'error', 'warning', 'info'
      validator: (value) => ['success', 'error', 'warning', 'info'].includes(value)
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 5000 // milliseconds
    }
  },
  watch: {
    visible(newVal) {
      if (newVal && this.duration > 0) {
        setTimeout(() => {
          this.close();
        }, this.duration);
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.notification-toast {
  position: fixed;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 500px;
  max-width: 700px;
  padding: 24px 28px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: flex-start;
  gap: 16px;
  z-index: 10000;
  animation: slideInDown 0.3s ease;
  
  &.success {
    background-color: #10b981;
    color: #fff;
  }
  
  &.error {
    background-color: #e53e3e;
    color: #fff;
  }
  
  &.warning {
    background-color: #f59e0b;
    color: #fff;
  }
  
  &.info {
    background-color: #3b82f6;
    color: #fff;
  }
}

.toast-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
}

.toast-content {
  flex: 1;
}

.toast-title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 6px;
}

.toast-message {
  font-size: 16px;
  opacity: 0.95;
  line-height: 1.5;
}

.toast-close {
  flex-shrink: 0;
  background: none;
  border: none;
  color: inherit;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.8;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    opacity: 1;
  }
}

@keyframes slideInDown {
  from {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}

.toast-enter-active, .toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter, .toast-leave-to {
  transform: translate(-50%, -100%);
  opacity: 0;
}

@media (max-width: 768px) {
  .notification-toast {
    top: 20px;
    left: 10px;
    right: 10px;
    transform: translateX(0);
    min-width: auto;
    max-width: none;
    padding: 20px 24px;
  }
  
  @keyframes slideInDown {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  .toast-enter, .toast-leave-to {
    transform: translateY(-100%);
    opacity: 0;
  }
}
</style>

